// extracted by mini-css-extract-plugin
module.exports = {"Collaborators":"styles_Collaborators__3O7Di"};